// src/components/resources/tools/generators/SocialMediaMockup/VerifiedBadges.tsx
//
// Presentational verified-badge SVGs extracted from SocialMediaMockupGenerator.

import type { FC } from 'react'

/**
 * Instagram verified badge SVG (official look).
 */
export const InstagramVerifiedBadge: FC = (): JSX.Element => (
  <span className="inline-flex items-center justify-center ml-1" style={{ lineHeight: 0 }}>
    <svg
      aria-label="Verified"
      viewBox="0 0 20 20"
      className="h-4 w-4"
      style={{ display: 'block' }}
    >
      <g>
        <radialGradient id="ig-verified-badge-gradient" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
          <stop offset="0%" stopColor="#5eaaff" />
          <stop offset="100%" stopColor="#0077f6" />
        </radialGradient>
        <path
          d="M10 1.75c.41 0 .81.16 1.11.45l1.13 1.09c.19.18.46.23.7.13l1.47-.6c.39-.16.84-.07 1.13.23l1.06 1.13c.29.3.38.74.23 1.13l-.6 1.47a.62.62 0 0 0 .13.7l1.09 1.13c.29.3.45.7.45 1.11 0 .41-.16.81-.45 1.11l-1.09 1.13a.62.62 0 0 0-.13.7l.6 1.47c.16.39.07.84-.23 1.13l-1.13 1.06a.82.82 0 0 1-1.13.23l-1.47-.6a.62.62 0 0 0-.7.13l-1.13 1.09a1.57 1.57 0 0 1-2.22 0l-1.13-1.09a.62.62 0 0 0-.7-.13l-1.47.6a.82.82 0 0 1-1.13-.23l-1.13-1.06a.82.82 0 0 1-.23-1.13l.6-1.47a.62.62 0 0 0-.13-.7l-1.09-1.13a1.57 1.57 0 0 1 0-2.22l1.09-1.13a.62.62 0 0 0 .13-.7l-.6-1.47a.82.82 0 0 1 .23-1.13l1.13-1.13a.82.82 0 0 1 1.13-.23l1.47.6c.24.1.51.05.7-.13l1.13-1.09A1.57 1.57 0 0 1 10 1.75z"
          fill="url(#ig-verified-badge-gradient)"
        />
        <path
          d="M13.2 7.2l-3.53 3.53-1.37-1.37a.75.75 0 1 0-1.06 1.06l1.9 1.9a.75.75 0 0 0 1.06 0l4.06-4.06a.75.75 0 1 0-1.06-1.06z"
          fill="#fff"
        />
      </g>
    </svg>
  </span>
)

/**
 * Facebook verified badge SVG (blue check on a rounded badge).
 */
export const FacebookVerifiedBadge: FC = (): JSX.Element => (
  <span className="inline-flex items-center justify-center ml-0.5" style={{ lineHeight: 0 }}>
    <svg aria-label="Verified" viewBox="0 0 24 24" className="h-3.5 w-3.5" style={{ display: 'block' }}>
      <path
        fill="#1877F2"
        d="M12 2c.97 0 1.86.5 2.37 1.32l.7 1.12 1.3-.25a2.8 2.8 0 0 1 3.27 2.37l.16 1.32 1.2.56a2.8 2.8 0 0 1 1.25 3.85l-.6 1.18.6 1.18a2.8 2.8 0 0 1-1.25 3.85l-1.2.56-.16 1.32a2.8 2.8 0 0 1-3.27 2.37l-1.3-.25-.7 1.12a2.8 2.8 0 0 1-4.74 0l-.7-1.12-1.3.25a2.8 2.8 0 0 1-3.27-2.37l-.16-1.32-1.2-.56a2.8 2.8 0 0 1-1.25-3.85l.6-1.18-.6-1.18a2.8 2.8 0 0 1 1.25-3.85l1.2-.56.16-1.32A2.8 2.8 0 0 1 7.63 4.2l1.3.25.7-1.12A2.8 2.8 0 0 1 12 2z"
      />
      <path
        d="M10.6 14.7l-2.1-2.1a.75.75 0 1 0-1.06 1.06l2.63 2.63a.75.75 0 0 0 1.06 0l5.03-5.02a.75.75 0 1 0-1.06-1.06z"
        fill="#fff"
      />
    </svg>
  </span>
)
